import { GetterTree } from "vuex";
import { ITagsViewState } from "./types";
import { RootState } from "../../types";

export const getters: GetterTree<ITagsViewState, RootState> = {

};
